export default __webpack_public_path__ + "static/media/steps2.089d8a9a.jpg";